import cookie from 'js-cookie';

import {COOKIE_PREFERRED_INSTITUTE_NUMBER_LOGGED_IN} from 'app/components/cookieWriter/constants';
import {PREFERRED_INSTITUTE_COOKIE_NAME, PREFERRED_INSTITUTE_NUMBER_COOKIE_NAME} from 'app/components/instituteSelection/constants';
import {Undef} from 'app/interface';

export const DEFAULT_PREFERRED_INSTITUTE_COOKIE = '0009';

export function setPreferredInstituteNumber(instituteNumber: string): void {
    cookie.set(PREFERRED_INSTITUTE_NUMBER_COOKIE_NAME, instituteNumber, {expires: 10950});
}

export function setPreferredInstitute(instituteUrl: string): void {
    const cookieValue = `${window.location.protocol}//${window.location.host}/${instituteUrl}`;
    cookie.set(PREFERRED_INSTITUTE_COOKIE_NAME, cookieValue, {expires: 10950});
}

export function getPreferredInstituteNumber(withDefault = true): Undef<string> {
    let cookieValue = cookie.get(COOKIE_PREFERRED_INSTITUTE_NUMBER_LOGGED_IN);

    if (!cookieValue) {
        cookieValue = cookie.get(PREFERRED_INSTITUTE_NUMBER_COOKIE_NAME);
    }

    if (cookieValue !== undefined) {
        return cookieValue;
    }

    if (withDefault) {
        return DEFAULT_PREFERRED_INSTITUTE_COOKIE;
    }
}

export const exportedForTesting = {
    DEFAULT_PREFERRED_INSTITUTE_COOKIE,
};
